import React from 'react';
import classNames from 'classnames';
import ReactMarkdown from 'react-markdown';
import { MARKDOWN_FEATURES, toMarkdownString } from 'utils/markdown/markdown';

const FEATURE_ELEMENTS = {
  [MARKDOWN_FEATURES.BOLD]: ['strong'],
  [MARKDOWN_FEATURES.ITALIC]: ['em'],
  [MARKDOWN_FEATURES.BULLET_LIST]: ['ul', 'li'],
  [MARKDOWN_FEATURES.ORDERED_LIST]: ['ol', 'li'],
  [MARKDOWN_FEATURES.HARD_BREAK]: ['br']
};

const BASE_ALLOWED_ELEMENTS = ['p'];

function buildAllowedElements(features) {
  const allowed = new Set(BASE_ALLOWED_ELEMENTS);

  features.forEach((feature) => {
    const elements = FEATURE_ELEMENTS[feature];

    if (elements) {
      elements.forEach((element) => allowed.add(element));
    }
  });

  return Array.from(allowed);
}

export default function MarkdownView({
  markdown,
  features = [],
  className = '',
  compact = false
}) {
  const value = toMarkdownString(markdown).trim();

  if (!value) {
    return null;
  }

  return (
    <div
      className={classNames(
        compact
          ? 'space-y-1 text-xs leading-5 text-gray-400 [&_ul]:list-disc [&_ol]:list-decimal [&_ul]:pl-5 [&_ol]:pl-5'
          : 'space-y-2 text-sm leading-6 text-gray-200 [&_ul]:list-disc [&_ol]:list-decimal [&_ul]:pl-5 [&_ol]:pl-5',
        className
      )}
    >
      <ReactMarkdown
        allowedElements={buildAllowedElements(features)}
        unwrapDisallowed
        skipHtml
      >
        {value}
      </ReactMarkdown>
    </div>
  );
}
